import api from '../../utils/axios';

export const searchFlight = async (flightNumber, date) => {
    try {
        const response = await api.get('/agent/tracking/flight/search', {
            params: { flight_number: flightNumber, date: date }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};
